import { TextSnippet } from "@mui/icons-material";
import { Button, Checkbox, FormControlLabel, MenuItem } from "@mui/material";
import moment from "moment";
import { useState } from "react";
import {
  getCantidadDiasBajaMedica,
  getFechaMasReciente,
} from "../../../../utils/datetimeUtils";
import ConfirmDialog from "../../../commons/dialog/confirmDialog";
import DarkerDisabledTextField from "../../../commons/formComponents/darkerDisabledTextField";
import FormikActions from "../../../commons/formik/formikActions";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import FormikDateTimePicker from "../../../commons/formik/formikDateTimePicker";
import FormikForm from "../../../commons/formik/formikForm";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikTextFieldSpeech from "../../../commons/formik/formikTextFieldSpeech";
import { StyledCommonForms } from "../../../styled/form";
import AppointmentControl from "../appointmentControl/appointmentControl";
import DiagnosisControlContainer from "../diagnosisControl/diagnosisControlContainer";
import DropZone from "../dropZone/dropZone";
import FormSectionDivider from "../formSectionDivider";
import { ietValidation, validateRequiredFields } from "../formValidation";
import InternmentContainer from "../internment/InternmentContainer";
import ProfessionalControl from "../professionalControl/professionalControl";

const Iet = ({
  handleClose,
  files,
  setFiles,
  handleSubmit,
  model,
  formValues,
  selectedDocument,
  openAppointment,
  handleAppointmentSubmit,
  handleCloseAppointment,
  handleOpenAppointment,
  appointmentModel,
  isView,
  disabled,
  idArt,
  lastProfessionalInfo,
}) => {
  const [professionalError, setProfessionalError] = useState(false);
  const [attachmentError, setAttachmentError] = useState(false);
  const [openMissingNextAppointDialog, setOpenMissingNextAppointDialog] = useState(false);
  const [selectedPredefinedTextId, setSelectedPredefinedTextId] = useState("");

  const fields = model.fields;
  const predefinedTexts = fields.textosPredefinidosIet?.options || [];
  const isObservacionesFreeText =
    fields.observaciones?.options === undefined ||
    fields.observaciones?.options === null;
  const showPredefinedTextSelector =
    model.configuration?.allowPredefinedTexts &&
    isObservacionesFreeText &&
    predefinedTexts.length > 0;
  const selectedPredefinedText = predefinedTexts.find(
    (texto) =>
      texto.id === selectedPredefinedTextId ||
      texto.id === Number(selectedPredefinedTextId),
  );

  const fechaAtencionMinDate =
    fields.fechaAtencion.validations && fields.fechaAtencion.validations.minDate
      ? fields.fechaPrimeraCuracion.options
        ? getFechaMasReciente(
          fields.fechaAtencion.validations.minDate,
          fields.fechaPrimeraCuracion.options,
        )
        : fields.fechaAtencion.validations.minDate
      : fields.fechaPrimeraCuracion.options
        ? fields.fechaPrimeraCuracion.options
        : undefined;

  return (
    <FormikForm
      artFields={fields}
      initialValues={formValues}
      enableReinitialize
      validationSchema={() => ietValidation(fechaAtencionMinDate)}
      validate={(values) => {
        const errors = validateRequiredFields(values, fields)
        if (model.configuration.requiresAttachment && files.length === 0) {
          errors.attachment = "Adjunto requerido";
          setAttachmentError(true);
        }
        return errors;
      }}
      onSubmit={(values) => {
        if (!professionalError) {
          if (!values.fechaHoraNuevoControl) {
            setOpenMissingNextAppointDialog(true);
            return;
          }
          handleSubmit(values);
        }
      }}>
      {({ values, setFieldValue }) => (
        <StyledCommonForms.FormContainer>

          <StyledCommonForms.FieldContainer>
            <FormSectionDivider title="Evolución" />
            {model.configuration.showTypeFormCombo && (
              <StyledCommonForms.RowContainer>
                <FormikSelect
                  name="nombreTipoFormulario"
                  label={`Tipo de Formulario Especifico ${fields.nombreTipoFormulario.required ? "*" : ""
                    }`}
                  value={formValues.nombreTipoFormulario}
                  variant="outlined"
                  sx={StyledCommonForms.input}
                  callBack={(e) => {
                    const selectedFormulario =
                      fields.tiposFormulario.options.find(
                        (f) => f.nombre === e,
                      );
                    setFieldValue(
                      "representa",
                      selectedFormulario?.representa?.trim(),
                    );
                  }}
                  disabled={disabled}>
                  {fields.tiposFormulario.options.map((f) => (
                    <MenuItem key={f.nombre} value={f.nombre}>
                      {f.formulario} - {f.nombre}
                    </MenuItem>
                  ))}
                </FormikSelect>
              </StyledCommonForms.RowContainer>
            )}
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikDateTimePicker
                  name="fechaAtencion"
                  label={`Fecha Hora de Atención ${fields.fechaAtencion.required ? "*" : ""
                    }`}
                  inputVariant="outlined"
                  disableFuture
                  sx={{ ...StyledCommonForms.input }}
                  disabled={disabled}
                  minDate={fechaAtencionMinDate}
                  autoComplete="off"
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <AppointmentControl
                  addAppointmentControl={
                    model.configuration.addAppointmentControl
                  }
                  appointmentModel={appointmentModel}
                  artFields={fields}
                  name="fechaHoraNuevoControl"
                  handleAppointmentSubmit={handleAppointmentSubmit}
                  openAppointment={openAppointment}
                  handleOpenAppointment={handleOpenAppointment}
                  handleCloseAppointment={handleCloseAppointment}
                  especialidadesProfesional={fields.especialidadProfesional}
                  required={fields.fechaHoraNuevoControl.required}
                  disabled={disabled}
                  idArt={idArt}
                  preloadedProfessional={values.profesionalApellidoNombre || lastProfessionalInfo.profesionalApellidoNombre}
                  preloadedMnMd={values.profesionalMnMp || lastProfessionalInfo.matricula}
                  preloadedSpecialty={values.especialidadInforme || lastProfessionalInfo.especialidadInforme}
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikAutocomplete
                name="nroFormularioFPA"
                label={`Pedido de Autorización para asociar ${fields.nroFormularioFPA.required ? "*" : ""}`}
                variant="outlined"
                options={fields.nroFormularioFPA.options}
                sx={StyledCommonForms.input}
                renderOption={(option) =>
                  `${moment(option.fecha).format("DD/MM/YYYY HH:mm")} ${option.estado ? "-" : ""
                  } ${option.estado || ""} ${option.detalle ? "-" : ""}  ${option.detalle || ""
                  }`
                }
                labelOption={(option) =>
                  `${moment(option.fecha).format("DD/MM/YYYY HH:mm")} ${option.estado ? "-" : ""
                  } ${option.estado || ""}`
                }
                filterOptions={(option) =>
                  moment(option.fecha).format("DD/MM/YYYY HH:mm") +
                  option.estado +
                  option.detalle
                }
                disabled={disabled}
              />
            </StyledCommonForms.RowContainer>
            {showPredefinedTextSelector && (
              <StyledCommonForms.RowContainer>
                <FormikSelect
                  name="textoPredefinidoIetId"
                  label="Texto Predefinido"
                  value={values.textoPredefinidoIetId || ""}
                  variant="outlined"
                  sx={{ flex: 1, marginRight: 2 }}
                  callBack={(value) => {
                    setSelectedPredefinedTextId(value || "");
                  }}
                  disabled={disabled}>
                  {predefinedTexts.map((texto) => (
                    <MenuItem key={texto.id} value={texto.id}>
                      {texto.patologia}
                    </MenuItem>
                  ))}
                </FormikSelect>
                <Button
                  onClick={() => {
                    if (!selectedPredefinedText) {
                      return;
                    }
                    const currentText = values.observaciones || "";
                    const separator = currentText.length > 0 ? "\n" : "";
                    setFieldValue(
                      "observaciones",
                      `${currentText}${separator}${selectedPredefinedText.descripcion}`,
                    );
                  }}
                  color="primary"
                  disabled={disabled || !selectedPredefinedText}
                  variant="contained"
                  startIcon={<TextSnippet />}
                  sx={{ whiteSpace: "nowrap", height: "fit-content", alignSelf: "center" }}>
                  Insertar Texto
                </Button>
              </StyledCommonForms.RowContainer>
            )}
            <StyledCommonForms.RowContainer>
              <FormikTextFieldSpeech
                id="observaciones"
                name="observaciones"
                label={`Evolución Tratamiento o Prácticas Realizadas ${fields.observaciones.required ? "*" : ""}`}
                type="text"
                variant="outlined"
                multiline
                minRows={3}

                sx={StyledCommonForms.input}
                disabled={disabled}
              />
            </StyledCommonForms.RowContainer>

            {model.configuration.showDaysOff && (
              <StyledCommonForms.RowContainer>
                <DarkerDisabledTextField
                  label="Días de Baja"
                  type="text"
                  variant="outlined"
                  value={getCantidadDiasBajaMedica(
                    values.fechaAtencion,
                    fields.fechaPrimeraCuracion.options,
                  )}
                  sx={StyledCommonForms.input}
                />
              </StyledCommonForms.RowContainer>
            )}

            {model.configuration.addRejectionSuggestion && (
              <StyledCommonForms.RowContainer>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.sugiereRechazo}
                      onChange={e => {
                        const newValue = e.target.checked;
                        setFieldValue("sugiereRechazo", newValue);
                        if (!newValue) {
                          setFieldValue("causal", null);
                        }
                      }}
                      name="sugiereRechazo"
                      disabled={disabled}
                    />
                  }
                  label="Sugerencia Rechazo"
                />
                {values.sugiereRechazo && (
                  <FormikSelect
                    name="causal"
                    label="Causa Rechazo"
                    value={values.causal}
                    variant="outlined"
                    sx={StyledCommonForms.input}
                    disabled={disabled}
                  >
                    {fields.causal.options.map((option, idx) => (
                      <MenuItem key={idx} value={option}>{option}</MenuItem>
                    ))}
                  </FormikSelect>
                )}
              </StyledCommonForms.RowContainer>
            )}
            {formValues.tratamientoAnterior ? (
              <StyledCommonForms.RowContainer>
                <DarkerDisabledTextField
                  label="Tratamiento Anterior"
                  type="text"
                  variant="outlined"
                  value={formValues.tratamientoAnterior}
                  multiline
                  sx={StyledCommonForms.input}
                />
              </StyledCommonForms.RowContainer>
            ) : (
              !isView &&
              fields.tratamientoAnterior.options && (
                <StyledCommonForms.RowContainer>
                  <DarkerDisabledTextField
                    label="Tratamiento Anterior"
                    type="text"
                    variant="outlined"
                    value={fields.tratamientoAnterior.options}
                    multiline
                    sx={StyledCommonForms.input}
                  />
                </StyledCommonForms.RowContainer>
              )
            )}
            <FormSectionDivider title="Diagnóstico" />
            <DiagnosisControlContainer
              idArt={idArt}
              fields={fields}
              disabled={disabled}
              showDescripcionDiagnostico
            />
            <FormSectionDivider title="Profesional" />
            <ProfessionalControl
              disabled={disabled}
              fields={fields}
              values={values}
              setFieldValue={setFieldValue}
              profesionalPreCarga={formValues.profesionalApellidoNombre}
              error={professionalError}
              setError={setProfessionalError}
              especialidadesProfesional={fields.especialidadProfesional}
              habilitarEspecialidadInforme={true}
              isView={isView}
              idArt={idArt}
            />

            {model.fields.internacion?.options?.find(
              (intern) => intern == values.representa,
            ) && (
                <>
                  <FormSectionDivider title="Internación" />
                  <InternmentContainer
                    fields={fields}
                    ietModel={formValues}
                    representa={values.representa}
                  />
                </>
              )}

            {model.configuration.showAttachments && (
              <div>
                <FormSectionDivider title="Adjuntos" />
                <StyledCommonForms.RowContainer>
                  <DropZone
                    files={files}
                    setFiles={setFiles}
                    configuration={model.configuration}
                    error={attachmentError}
                    setError={setAttachmentError}
                    disabled={disabled}
                    selectedDocument={selectedDocument}
                    accept={model.configuration.availableExtensions}
                  />
                </StyledCommonForms.RowContainer>
              </div>
            )}
          </StyledCommonForms.FieldContainer>
          <StyledCommonForms.ActionsContainer>
            <FormikActions handleCancel={handleClose} disabled={disabled} />
          </StyledCommonForms.ActionsContainer>
          <ConfirmDialog
            handleClose={() => handleSubmit(values)}
            handleConfirm={() => {
              setOpenMissingNextAppointDialog(false);
              handleOpenAppointment();
            }}
            open={openMissingNextAppointDialog}
            cancelText="Guardar y Finalizar"
            confirmText="Guardar y Continuar"
            title={"Fecha de Próxima Consulta"}
            text={"Se detectó que no ha asignado una Fecha de Próxima Consulta. ¿Desea agregarla antes de guardar el formulario?"}
          />
        </StyledCommonForms.FormContainer>
      )}
    </FormikForm>
  );
};

export default Iet;
